// First, before anything can start a silent sign-in: makes concurrent renewals share one refresh.
import '@/plugins/oidc-single-flight'
import { createApp } from 'vue'
import { Log } from 'oidc-client-ts'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { apiPlugin } from '@/plugins/axios'
import logger, { loggerPlugin } from '@/plugins/logger'
import { initSentry } from '@/plugins/sentry'
import { initPlausible } from '@/plugins/plausible'
import { registerServiceWorker } from '@/utils/push'

if (import.meta.env.DEV) {
  Log.setLogger(logger)
  Log.setLevel(Log.INFO)
}

const app = createApp(App)

initSentry(app)
initPlausible()

app.use(loggerPlugin)
app.use(apiPlugin)
app.use(store)
app.use(router)
app.use(vuetify)

app.mount('#app')

// Push notifications need a service worker; registering it is harmless without
// any subscription and keeps the click on a notification working after reloads.
registerServiceWorker()
